import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {SearchPaginatedAdxPaymentResponse} from '../model/search-paginated-adx-payment-response';

@Injectable({
  providedIn: 'root'
})

export class AdxPaymentGridService implements GridGetService<SearchPaginatedAdxPaymentResponse> {
  private readonly baseUrl = 'dbov2/adx-payment-detail/search';
  private readonly http = inject(HttpClient);

  getItems({filters, page, sort} : GridServiceParams): Observable<GridServiceResponse<SearchPaginatedAdxPaymentResponse>>  {
    const params:Record<string, string | number | boolean> = {
      pageSize:  page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: this.getMappedPaymentPropertyName(sort?.active || ''),
      orderKey: sort?.direction || '',

      tripId: filters?.['tripId'] ?? '',
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<SearchPaginatedAdxPaymentResponse>>(`${this.baseUrl}`, { params: {...params} })
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
    }));
  }

  private getMappedPaymentPropertyName(propertyName: string): string {
    switch (propertyName) {
      case 'fmsAdxPaymentDetailId':
        return 'Id';
      case 'vendorName':
        return 'adxBooking.Vendor.VendorName';
      case 'payTypeName':
        return 'payType.PayTypeName';
      case 'payMethodName':
        return 'payMethod.PaymethodName';
      case 'profileTypeName':
        return 'profileType.ProfileTypeName';
      case 'branchName':
        return 'branch.Name';
      case 'bankName':
        return 'bank.Name';
      case 'tripExternalReference':
        return 'trip.ExternalReference';
      case 'adxInvoiceRecordLocator':
        return 'trip.ExternalReference';
      case 'tripRecordLocator':
        return 'trip.ExternalReference';
      case 'dateUpdated':
        return 'DateUpdated';  
      case 'issueDate':
        return 'PaymentDate';
      default:
        return propertyName;
    }
  }
}